<template>
  <NavBar />
  <main class="random-page">
    <div class="container random-container">
      <router-link :to="{ name: 'Excercise' }" class="back-link"><i class="bi bi-arrow-left" aria-hidden="true"></i>Tüm egzersizler</router-link>
      <header class="page-header">
        <span class="eyebrow">KONUŞMA PRATİĞİ</span>
        <h1>Bir soru, yeni bir sohbet.</h1>
        <p>Sorunu seç, kelimelerden ilham al ve kendini İngilizce ifade et.</p>
      </header>

      <section class="practice-card" aria-label="Rastgele soru" :aria-busy="isLoading">
        <div class="practice-layout">
          <div class="question-panel">
            <span class="panel-label"><i class="bi bi-chat-dots" aria-hidden="true"></i>Sıra sende</span>
            <div class="question-content" aria-live="polite" aria-atomic="true">
              <p v-if="isLoading" class="question-state" role="status"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span>Sorun hazırlanıyor…</p>
              <template v-else-if="question">
                <h2 lang="en">{{ question }}</h2>
                <p class="question-hint">Biraz düşün, ardından cevabını sesli söyle.</p>
              </template>
              <p v-else class="question-state">{{ loadError ? 'Soru yüklenemedi. Lütfen tekrar dene.' : 'Yeni bir soruyla pratiğe başla.' }}</p>
            </div>
          </div>
          <aside class="words-panel" aria-labelledby="words-title">
            <span class="words-icon" aria-hidden="true"><i class="bi bi-lightbulb"></i></span>
            <h2 id="words-title">Cevabına renk kat</h2>
            <p>Soruyu cevaplarken bu kelimeleri kullanmaya çalış.</p>
            <ul v-if="question && !isLoading" class="word-list" lang="en">
              <li v-for="(word, index) in words" :key="index">{{ word }}</li>
            </ul>
            <p v-else class="words-placeholder">Kelimeler sorunla birlikte burada görünecek.</p>
          </aside>
        </div>
        <div class="practice-actions">
          <p>Her yeni soru, kendini ifade etmek için yeni bir fırsat.</p>
          <button type="button" class="question-button" :disabled="isLoading" @click="GetQuestion()">
            <i v-if="!isLoading" class="bi bi-arrow-repeat" aria-hidden="true"></i>
            {{ isLoading ? 'Hazırlanıyor…' : loadError ? 'Tekrar dene' : 'Başka soru dene' }}
          </button>
        </div>
      </section>
      <p v-if="loadError && question && !isLoading" class="error-note" role="alert">Yeni soru yüklenemedi. Mevcut soruyla devam edebilir veya tekrar deneyebilirsin.</p>
    </div>
  </main>
  <FooterInPage />
</template>

<script>
import { mapActions } from "vuex";
import { LoadingToast,UpdateToast,ToastType } from "@/common/notification.js";
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
export default {
  name: 'RandomQuestion',
  data() {
    return {
      question:'',
      wordOne:'',
      wordTwo:'',
      wordThree:'',
      wordFour:'',
      isLoading:false,
      loadError:false,
    };
  },
  components: {
    NavBar,
    FooterInPage,
  },
  computed:{
    words() {
      return [this.wordOne, this.wordTwo, this.wordThree, this.wordFour].filter(Boolean);
    },
  },
  methods: {
    ...mapActions(["GetRandomQuestion"]),
    async GetQuestion(){
      if (this.isLoading) return;
      this.isLoading = true;
      this.loadError = false;
      let toastId = LoadingToast();
      await this.GetRandomQuestion()
      .then((res)=>{
        this.question = res.question;
        this.wordOne = res.answerOne;
        this.wordTwo = res.answerTwo;
        this.wordThree = res.answerThree;
        this.wordFour = res.answerFour;
        UpdateToast(toastId,res.description,ToastType().SUCCESS,100);
      })
      .catch((err)=>{
        this.loadError = true;
        UpdateToast(toastId,err.message,ToastType().ERROR);
      })
      .finally(()=>{
        this.isLoading = false;
      });
    },
  },
  mounted: function() {
    this.GetQuestion();
  }
}
</script>
<style scoped>
.random-page { padding: 36px 0 48px; background: #f7f9f7; color: #24382e; }
.random-container { max-width: 1080px; }
.back-link { display: inline-flex; align-items: center; gap: 8px; min-height: 44px; margin-bottom: 24px; color: #637269; text-decoration: none; font-size: .85rem; }
.back-link:hover { color: var(--brand-link); }
.page-header { margin-bottom: 32px; }
.eyebrow { display: block; margin-bottom: 14px; color: var(--brand-link); font-size: .72rem; font-weight: 700; letter-spacing: .12em; }
.page-header h1 { margin-bottom: 14px; font-size: clamp(1.9rem, 4vw, 2.8rem); font-weight: 700; letter-spacing: -.035em; line-height: 1.2; }
.page-header > p { margin: 0; color: #637269; line-height: 1.7; }
.practice-card { background: #fff; border: 1px solid #e4eae4; border-radius: 20px; box-shadow: 0 12px 40px rgba(36, 56, 46, .04); overflow: hidden; }
.practice-layout { display: grid; grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr); gap: 32px; padding: 32px; }
.question-panel { min-width: 0; padding: 8px; }
.panel-label { display: inline-flex; align-items: center; gap: 10px; color: var(--brand-link); font-size: .85rem; font-weight: 600; }
.panel-label i { font-size: 1.2rem; }
.question-content { display: flex; flex-direction: column; justify-content: center; min-height: 240px; padding: 28px 0 12px; }
.question-content h2 { margin: 0 0 20px; font-size: clamp(1.5rem, 3vw, 2rem); font-weight: 600; line-height: 1.45; letter-spacing: -.025em; overflow-wrap: anywhere; }
.question-hint, .question-state { color: #637269; font-size: .88rem; line-height: 1.7; margin: 0; }
.question-state { display: flex; align-items: center; gap: 12px; }
.words-panel { padding: 28px; border-radius: 14px; background: #edf5eb; }
.words-icon { display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; margin-bottom: 18px; background: #fff; color: var(--brand-link); border-radius: 12px; font-size: 1.2rem; }
.words-panel h2 { font-size: 1.1rem; font-weight: 700; margin-bottom: 10px; }
.words-panel p { color: #516556; font-size: .88rem; line-height: 1.7; margin-bottom: 20px; }
.word-list { display: flex; flex-wrap: wrap; gap: 10px; list-style: none; padding: 0; margin: 0; }
.word-list li { max-width: 100%; overflow-wrap: anywhere; padding: 8px 14px; background: #fff; color: var(--brand-link); border: 1px solid #dce9dc; border-radius: 9px; font-size: .9rem; font-weight: 600; }
.words-panel .words-placeholder { margin: 0; font-size: .8rem; }
.practice-actions { display: flex; align-items: center; justify-content: space-between; gap: 24px; border-top: 1px solid #e4eae4; padding: 24px 32px; }
.practice-actions p { margin: 0; color: #637269; font-size: .82rem; line-height: 1.7; }
.question-button { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; gap: 10px; min-height: 48px; padding: 12px 20px; border: 0; border-radius: 10px; background: var(--brand-link); color: #fff; font-size: .9rem; font-weight: 600; }
.question-button:hover:not(:disabled) { background: var(--brand-primary-hover); }
.question-button:disabled { opacity: .7; cursor: wait; }
.question-button:focus-visible, .back-link:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 4px; }
.error-note { margin: 18px 0 0; color: #9a3e2b; font-size: .85rem; line-height: 1.7; }
@media (max-width: 767.98px) {
  .random-page { padding: 20px 0 32px; }
  .back-link { margin-bottom: 20px; }
  .page-header { margin-bottom: 24px; }
  .practice-layout { grid-template-columns: 1fr; gap: 20px; padding: 20px; }
  .question-panel { padding: 4px; }
  .question-content { min-height: 180px; }
  .words-panel { padding: 22px; }
  .practice-actions { flex-direction: column; align-items: stretch; gap: 16px; padding: 20px; }
  .question-button { width: 100%; }
}
</style>
